<template>
  <div>
    <el-dialog
      :visible.sync="showModal"
      title="Campaign Detail"
      @open="getCampaignUsers"
      @closed="handleClosed"
    >
      <div>IO Number: {{ ioNumber }}</div>
      
      <el-table
        v-loading="isLoadingCampaignUsers"
        :data="campaignUsers"
      >
        <el-table-column
          prop="campaign_id"
          label="Campaing ID"
          width="80"
        />

        <el-table-column
          prop="user_id"
          label="User Id"
          width="80"
        />

        <el-table-column
          prop="campaing_name"
          label="Campaing Name"
          width="200"
        />

        <el-table-column
          prop="transaction_date"
          label="Date"
          width="100"
        />

        <el-table-column
          label="Username"
          min-width="80"
        >
          <template slot-scope="{ row }">
            <span>{{ row.first_name }} {{ row.last_name }}</span>
          </template>
        </el-table-column>

        <el-table-column
          prop="email"
          label="Email"
          min-width="150"
        />

        <el-table-column
          label="Amount"
          min-width="80"
        >
          <template slot-scope="{ row }">
            <span>{{ row.currency }} {{ row.amount }}</span>
          </template>
        </el-table-column>

        <el-table-column label="Status">
          <template slot-scope="{ row }">
            <span>{{ row.payment_status }}</span>
          </template>
        </el-table-column>

        <el-table-column
          fixed="right"
          label="Actions"
          align="center"
          width="120"
        >
          <template slot-scope="{ row }">
            <el-button
              :disabled="row.payment_status === 'paid'"
              size="mini"
              type="warning"
              icon="el-icon-tickets"
              circle
              @click="showUpdateModal(row)"
            />

            <el-button
              :disabled="row.payment_status === 'paid'"
              size="mini"
              type="danger"
              icon="el-icon-delete"
              circle
              @click="handleDelete(row)"
            />
          </template>
        </el-table-column>

      </el-table>
    </el-dialog>

    <campaign-payment-update-detail-modal
      :show="isShowUpdateDetailModal"
      :campaign-user="editingUser"
      @close="handleUpdateModalClose"
      @paid="handlePaidCampaignUser"
    />
  </div>
</template>

<script>
import CampaignPaymentUpdateDetailModal from './CampaignPaymentUpdateDetailModal.vue'
import { getCampaignPaymentUsers, deleteCampaignOrder } from '../../../api/rewardsnap'

export default {
  name: 'CampaignPaymentDetailModal',
  components: {
    CampaignPaymentUpdateDetailModal,
  },
  props: {
    ioNumber: {
      type: String,
      required: true,
      default: '',
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      campaignUsers: [],
      editingUser: {},
      isShowUpdateDetailModal: false,
      isLoadingCampaignUsers: false,
    }
  },
  computed: {
    showModal: {
      get() {
        return this.show
      },
      set(value) {
        if (!value) {
          this.$emit('close')
        }
      },
    },
  },
  methods: {
    async getCampaignUsers() {
      this.isLoadingCampaignUsers = true
      try {
        const response = await getCampaignPaymentUsers(this.ioNumber)
        const users = response.data
        if (Array.isArray(users)) {
          this.campaignUsers = []

          users.forEach(user => {
            let item = user

            if (item.amount == parseInt(item.amount)) {
              item.amount = parseInt(item.amount)
            }

            this.campaignUsers.push(item)
          })
        }
        this.isLoadingCampaignUsers = false
      } catch (error) {
        this.isLoadingCampaignUsers = false
      }
    },
    showUpdateModal(user) {
      this.editingUser = user
      this.isShowUpdateDetailModal = true
    },
    async handleDelete(campaignUser) {
      try {
        const response = await deleteCampaignOrder(campaignUser.campaign_id, campaignUser.user_id)
        this.isLoading = false
        this.handleClosed()
      } catch (error) {
        this.isLoading = false
      }
    },
    handleClosed() {
      this.cleanUp()
    },
    cleanUp() {
      this.campaignUsers = []
      this.isLoadingCampaignUsers = false
    },
    handleUpdateModalClose() {
      this.isShowUpdateDetailModal = false
      this.editingUser = {}
    },
    handlePaidCampaignUser(paidResult) {
      this.campaignUsers = this.campaignUsers.map((user) => {
        if (user.user_id === paidResult.uid) {
          user.payment_status = paidResult.payout_status
          user.currency = paidResult.currency
          user.amount = paidResult.amount
        }
        return user
      })
    },
  },
}
</script>

<style lang="scss" scoped>

</style>
